unable to read source [project]/node_modules/.pnpm/superjson@2.2.6/node_modules/superjson/src/registry.ts